<template>
    <div>
        <!-- Form -->
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="mb-1">{{$t('Company name')}}</label>
                    <small class="form-text text-muted">{{$t('Your company brand/known name.')}}</small>
                    <b-form-input v-model="company.name" type="text" :placeholder="$t('Ex.:ProfiDental') "></b-form-input>
                </div>
            </div>

            <div class="col-12">
                <div class="form-group">
                    <label class="mb-1">{{$t('Company description')}}</label>
                    <small
                        class="form-text text-muted"
                    >{{$t('Describe your company in few words so no one wants to read long text.')}}</small>
                    <b-form-textarea
                        id="textarea1"
                        v-model="company.description"
                        :placeholder="$t('Ex.: We are experts in dental care')"
                        :rows="3"
                        :max-rows="6"
                    ></b-form-textarea>
                </div>
            </div>
        </div>

        <hr class="mt-4 mb-5" />
        <div class="row">
            <div class="col-12 col-md-6">
                <!-- Public profile -->
                <custom-switch
                    v-model="company.public"
                    value="yes"
                    id="isPublicCompany"
                    :title="$t('Public company')"
                    :subtitle="$t('Making your profile public means that anyone on the 32Desk network will be able to find you')"
                ></custom-switch>
            </div>
            <div class="col-12 col-md-6">
                <div class="row">
                    <div class="col-auto" v-if="company.avatar">
                        <avatar :src="company.avatar.preview" size="avatar-xxl" type="rounded"></avatar>
                    </div>
                    <div class="col">
                        <button class="btn btn-white" @click="openModal({id:'mediaModal', multiple:true})">
                            <span class="fe fe-image"></span>
                            {{$t('Set photo')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- / .row -->
        <button-loading
            class="btn btn-lg btn-primary mb-3"
            :loading="isSavePending"
            @click="saveCompany()"
        >{{$t('Save')}}</button-loading>
        <media-modal category="profile" id="mediaModal" :action="useImage"></media-modal>
    </div>
</template>

<script>
import Navigation from './Navigation.vue';
import CustomSwitch from '@/components/CustomSwitch.vue';
import MediaModal from '@/components/MediaModal.vue';
import Avatar from '@/components/Avatar.vue';
import ButtonLoading from '@/components/ButtonLoading'
import { companyMixins } from './mixins.js'
import { modalMixins } from '@/mixins/modal.js'

export default {
    name: 'company-generals',
    components: {
        Navigation,
        CustomSwitch,
        MediaModal,
        ButtonLoading,
        Avatar
    },
    mixins: [companyMixins, modalMixins],

    data() {
        return {};
    },
    created() {
        // this.getMyCompany("mine").then(data => {
        //     console.log('data', data);
        //     // this.model = data || {};
        // });
    },
    methods: {
        useImage(image) {
            this.company.avatar_id = image._id;
            this.company.avatar = image;

            const company = this.company.clone()
            company.commit();

        },
    }


}
</script>
